import { useQuery } from '@tanstack/react-query';
import { getUsers } from '../services/usersService';

const BASE = 'users';

export const usersQueryKeys = {
  base: () => [BASE],
  list: (data) => data ? [BASE, 'list', data] : [BASE, 'list'],
}

export const useGetUsers = () => {
  return useQuery({
    queryKey: usersQueryKeys.list(),
    queryFn: getUsers,
  });
};